export type AppRole = 'owner' | 'admin' | 'member' | 'viewer';

const OWNER_ROLE_ALIASES = ['owner'] as const;
const ADMIN_ROLE_ALIASES = ['admin'] as const;
const MEMBER_ROLE_ALIASES = ['member'] as const;
const VIEWER_ROLE_ALIASES = ['viewer'] as const;

export function normalizeRoleName(role: string | null | undefined): string {
  return (role ?? '').trim().toLowerCase();
}

export function isAdminRoleName(role: string | null | undefined): boolean {
  const normalized = normalizeRoleName(role);
  return ADMIN_ROLE_ALIASES.includes(normalized as (typeof ADMIN_ROLE_ALIASES)[number]);
}

export function isOwnerRoleName(role: string | null | undefined): boolean {
  const normalized = normalizeRoleName(role);
  return OWNER_ROLE_ALIASES.includes(normalized as (typeof OWNER_ROLE_ALIASES)[number]);
}

export function normalizeAppRole(role: string | null | undefined): AppRole {
  const normalized = normalizeRoleName(role);
  if (OWNER_ROLE_ALIASES.includes(normalized as (typeof OWNER_ROLE_ALIASES)[number])) return 'owner';
  if (ADMIN_ROLE_ALIASES.includes(normalized as (typeof ADMIN_ROLE_ALIASES)[number])) return 'admin';
  if (MEMBER_ROLE_ALIASES.includes(normalized as (typeof MEMBER_ROLE_ALIASES)[number])) return 'member';
  if (VIEWER_ROLE_ALIASES.includes(normalized as (typeof VIEWER_ROLE_ALIASES)[number])) return 'viewer';
  return 'viewer';
}

export function hasAnyRole(
  hasRole: (roleName: string) => boolean,
  roles: readonly string[],
): boolean {
  return roles.some((role) => hasRole(role));
}

export function hasAdminRole(hasRole: (roleName: string) => boolean): boolean {
  return hasAnyRole(hasRole, [...OWNER_ROLE_ALIASES, ...ADMIN_ROLE_ALIASES]);
}
